<template>
  <!--  <md-card class="root">
    <ul class="nav nav-tabs ">
      <li
        class="pull-left"
        v-for="tab in goalTabs"
        :key="tab.id"
        :class="{ active: selectedGoalTab === tab.alias }"
      >
        <a href="javascript:void(0)" @click="selectedGoalTab = tab.alias">
          {{ tab.name }}
        </a>
      </li>
    </ul>

    <md-card-content>
      <form class="form-inline">
        <div class="form-group" v-if="selectedGoalTab === 'DAILY'">
          <label class="label-input">Daily </label>
          <input type="number" class="input-timer" v-model="dailyGoal" />
          <span v-if="selectedDailyGoal !== ''"> for: {{formatDateTable(selectedDailyGoal.created_at)}}</span>
        </div>
        <div class="form-group" v-if="selectedGoalTab === 'MONTHLY'">
          <label class="label-input">Monthly </label>
          <input type="number" class="input-timer" v-model="monthGoal" />
             <span v-if="selectedMonthlyGoal !== ''"> for: {{formatDateTable(selectedMonthlyGoal.created_at)}}</span>

        </div>
      </form>
    </md-card-content>

    <md-card-actions>
      <md-progress-spinner
        class="spinner-bottom-ms"
        v-if="showSpinner"
        :md-diameter="15"
        :md-stroke="3"
        md-mode="indeterminate"
      ></md-progress-spinner>
      <button
        type="button"
        v-if="
          !showNewDaily && selectedGoalTab === 'DAILY' && selectedDailyGoal !== ''
        "
        @click="updateDailyGoal()"
        class="btn btn-primary"
      >
        Update
      </button>
      <button
        type="button"
        v-if="
          !showNewMonth &&
            selectedGoalTab === 'MONTHLY' &&
            selectedMonthlyGoal !== ''
        "
        @click="updateMonthlyGoal()"
        class="btn btn-primary"
      >
        Update
      </button>
      <button
        type="button"
        v-if="!showNewDaily && selectedGoalTab === 'DAILY'"
        @click="showNewDaily = true;
             dailyGoal=null
               "
        class="btn btn-success"
      >
        New
      </button>
        <button
                type="button"
                v-if="!showNewMonth && selectedGoalTab === 'MONTHLY'"
                @click="showNewMonth = true;
monthGoal=null;"

                class="btn btn-success">
            New
        </button>
      <button
        type="button"
        v-if="showNewDaily"
        @click="
        createDailyGoal()
        "
        class="btn btn-success">
        Save
      </button>
        <button type="button"
                v-if="showNewMonth"
                @click="createMonthlyGoal()"
                class="btn btn-success">
            Save
        </button>
      <button type="button" class="btn btn-danger" @click="$router.push('/')">
        Cancel
      </button>
    </md-card-actions>
  </md-card>-->

  <div class="styleCard">
    <ul class="style-nav style2">
      <li
        v-for="tab in goalTabs"
        :key="tab.id"
        :class="{ active: selectedGoalTab === tab.alias }"
        @click="selectedGoalTab = tab.alias"
      >
        {{ tab.name }}
      </li>
    </ul>
    <div class="form-body">
      <form class="form-inline">
        <div class="form-group" v-if="selectedGoalTab === 'DAILY'">
          <label class="label-input">Daily </label>
          <input type="number" class="input-timer" v-model="dailyGoal" />
          <span v-if="selectedDailyGoal !== ''">
            for: {{ formatDateTable(selectedDailyGoal.created_at) }}</span
          >
        </div>
        <div class="form-group" v-if="selectedGoalTab === 'WEEKLY'">
          <label class="label-input">Weekly </label>
          <input type="number" class="input-timer" v-model="weekGoal" />
          <span v-if="selectedWeeklyGoal !== ''">
            for: {{ formatDateTable(selectedWeeklyGoal.created_at) }}</span
          >
        </div>
        <div class="form-group" v-if="selectedGoalTab === 'MONTHLY'">
          <label class="label-input">Monthly </label>
          <input type="number" class="input-timer" v-model="monthGoal" />
          <span v-if="selectedMonthlyGoal !== ''">
            for: {{ formatDateTable(selectedMonthlyGoal.created_at) }}</span
          >
        </div>
      </form>
      <button
        type="button"
        v-if="!showNewDaily && selectedGoalTab === 'DAILY'"
        @click="createDailyGoal()"
        class="bttn bttn-blue"
      >
        Update
      </button>
      <button
        type="button"
        v-if="!showNewWeekly && selectedGoalTab === 'WEEKLY'"
        @click="createWeeklyGoal()"
        class="bttn bttn-blue"
      >
        Update
      </button>
      <button
        type="button"
        v-if="!showNewMonth && selectedGoalTab === 'MONTHLY'"
        @click="createMonthlyGoal()"
        class="bttn bttn-blue"
      >
        Update
      </button>
      <!--      <button-->
      <!--        type="button"-->
      <!--        v-if="!showNewDaily && selectedGoalTab === 'DAILY'"-->
      <!--        @click="-->
      <!--          showNewDaily = true;-->
      <!--          dailyGoal = null;-->
      <!--        "-->
      <!--        class="bttn bttn-green"-->
      <!--      >-->
      <!--        New-->
      <!--      </button>-->
      <!--      <button-->
      <!--        type="button"-->
      <!--        v-if="!showNewMonth && selectedGoalTab === 'MONTHLY'"-->
      <!--        @click="-->
      <!--          showNewMonth = true;-->
      <!--          monthGoal = null;-->
      <!--        "-->
      <!--        class="bttn bttn-green"-->
      <!--      >-->
      <!--        New-->
      <!--      </button>-->
      <button
        type="button"
        v-if="showNewDaily"
        @click="createDailyGoal()"
        class="bttn bttn-green"
      >
        Save
      </button>
      <button
        type="button"
        v-if="showNewWeekly"
        @click="createDailyGoal()"
        class="bttn bttn-green"
      >
        Save
      </button>
      <button
        type="button"
        v-if="showNewMonth"
        @click="createMonthlyGoal()"
        class="bttn bttn-green"
      >
        Save
      </button>
      <button type="button" class="bttn bttn-red" @click="$router.push('/')">
        Cancel
      </button>
    </div>
  </div>
</template>

<script>
import apiClientCreator from "../../../helpers/api/request";
import moment from "moment";

export default {
  name: "DepositGoalPanel",
  data() {
    return {
      showNewDaily: false,
      showNewWeekly: false,
      showNewMonth: false,
      dailyGoal: null,
      monthGoal: null,
      weekGoal: null,
      selectedDailyGoal: "",
      selectedWeeklyGoal: "",
      selectedMonthlyGoal: "",
      showSpinner: false,
      selectedGoalTab: "DAILY",
      goalTabs: [
        {
          id: 1,
          name: "DAILY",
          alias: "DAILY"
        },
        {
          id: 3,
          name: "WEEKLY",
          alias: "WEEKLY"
        },
        {
          id: 2,
          name: "MONTHLY",
          alias: "MONTHLY"
        }
      ]
    };
  },
  created() {
    this.getDailyGoal();
    this.getWeeklyGoal();
    this.getMonthlyGoal();
  },
  methods: {
    getDailyGoal() {
      this.showSpinner = true;
      let vm = this;
      let apiClient = apiClientCreator(`admin/settings/deposits/goal/daily`);
      apiClient.get("").then(function(res) {
        vm.selectedDailyGoal = res.data;
        if (vm.selectedDailyGoal !== "") {
          vm.dailyGoal = vm.selectedDailyGoal.goal_count;
        }

        vm.showSpinner = false;
        vm.$store.commit("clients/setUpdateDepCharts", true);
      });
    },
    getWeeklyGoal() {
      this.showSpinner = true;
      let vm = this;
      let apiClient = apiClientCreator(`admin/settings/deposits/goal/weekly`);
      apiClient.get("").then(function(res) {
        vm.selectedWeeklyGoal = res.data;
        if (vm.selectedWeeklyGoal !== "") {
          vm.weekGoal = vm.selectedWeeklyGoal.goal_count;
        }

        vm.showSpinner = false;
        vm.$store.commit("clients/setUpdateDepCharts", true);
      });
    },
    getMonthlyGoal() {
      this.showSpinner = true;
      let vm = this;
      let apiClient = apiClientCreator(`admin/settings/deposits/goal/monthly`);
      apiClient.get("").then(function(res) {
        vm.selectedMonthlyGoal = res.data;
        if (vm.selectedMonthlyGoal !== "") {
          vm.monthGoal = vm.selectedMonthlyGoal.goal_count;
        }
        vm.showSpinner = false;
        vm.$store.commit("clients/setUpdateDepCharts", true);
      });
    },

    createDailyGoal() {
      this.showSpinner = true;
      let vm = this;
      let apiClient = apiClientCreator(`admin/settings/deposits/goal/new`);
      apiClient
        .post("", { goal_count: this.dailyGoal, goal_type: "DAILY" })
        .then(function(res) {
          vm.getDailyGoal();
          vm.showNewDaily = false;
          vm.$emit("updated");
          vm.showSpinner = false;
          vm.$store.commit("clients/setUpdateDepCharts", true);
        });
    },
    createWeeklyGoal() {
      this.showSpinner = true;
      let vm = this;
      let apiClient = apiClientCreator(`admin/settings/deposits/goal/new`);
      apiClient
        .post("", { goal_count: this.weekGoal, goal_type: "WEEKLY" })
        .then(function(res) {
          vm.getWeeklyGoal();
          vm.showNewDaily = false;
          vm.$emit("updated");
          vm.showSpinner = false;
          vm.$store.commit("clients/setUpdateDepCharts", true);
        });
    },
    createMonthlyGoal() {
      this.showSpinner = true;
      let vm = this;
      let apiClient = apiClientCreator(`admin/settings/deposits/goal/new`);
      apiClient
        .post("", { goal_count: this.monthGoal, goal_type: "MONTH" })
        .then(function(res) {
          vm.showNewMonth = false;
          vm.getMonthlyGoal();
          vm.$emit("updated");
          vm.showSpinner = false;
          vm.$store.commit("clients/setUpdateDepCharts", true);
        });
    },
    updateDailyGoal() {
      this.showSpinner = true;
      let vm = this;
      let apiClient = apiClientCreator(
        `admin/settings/deposits/goal/update/${this.selectedDailyGoal.id}`
      );
      apiClient.put("", { goal_count: this.dailyGoal }).then(function(res) {
        vm.getDailyGoal();
        vm.showNewDaily = false;
        vm.$emit("updated");
        vm.showSpinner = false;
        vm.$store.commit("clients/setUpdateDepCharts", true);
      });
    },
    updateMonthlyGoal() {
      this.showSpinner = true;
      let vm = this;
      let apiClient = apiClientCreator(
        `admin/settings/deposits/goal/update/${this.selectedMonthlyGoal.id}`
      );
      apiClient.put("", { goal_count: this.monthGoal }).then(function(res) {
        vm.getMonthlyGoal();
        vm.showNewMonth = false;
        vm.$emit("updated");
        vm.showSpinner = false;
        vm.$store.commit("clients/setUpdateDepCharts", true);
      });
    },
    formatDateTable(date) {
      return moment(String(date)).format("DD/MM/YY");
    }
  }
};
</script>

<style scoped>
.root {
  width: 327px;
  margin-left: auto;
  margin-right: auto;
}
.form-group {
  margin-right: 10px;
}
.label-input {
  margin-right: 10px;
}
.btn {
  margin: 5px;
}
.input-timer {
  width: 80px;
  padding-left: 10px;
  border-radius: 5px;
  border-style: solid;
  border-color: #90a4ae;
  height: 30px;
  border-width: thin;
  overflow: hidden;
  text-overflow: ellipsis;
  font-size: 8pt;
  box-sizing: border-box;
}
.w50 {
  width: calc(50% - 0.2rem);
}
.left {
  float: left;
}
.margin {
  margin: 0.5rem;
}
.margin_r_hf {
  margin-right: 0.2rem;
}
.margin_l_c {
  margin-left: 0;
}
.styleCard {
  box-shadow: 0px 9px 20px rgba(0, 0, 0, 0.05);
  border-radius: 5px;
  overflow: hidden;
  height: 150px;
  max-width: 300px;
  position: absolute;
  margin: auto;
  top: 0;
  right: 0;
  bottom: 70px;
  left: 0;

  font-family: Montserrat;
}

.style-nav {
  margin: 0;
  padding: 0;
  list-style: none;
  display: flex;
  position: relative;
  /*
    background: white;
  */
}
.style-nav.style2 li {
  /*border-radius: 5px 5px 0px 0px;*/
  transition: transform 0.1s ease;
}
.style-nav.style2 li:not(:last-child) {
  margin-right: 2px;
}

.style-nav li {
  max-width: 100%;
  min-width: 72px;
  height: 30px;
  margin: 0;
  cursor: pointer;
  background: white;
  border-radius: 0;
  font-size: 12px;
  text-align: center;
  vertical-align: middle;
  line-height: 30px;
  border-bottom: 2px solid transparent;
  flex-grow: 1;
  transition: background 0.2s ease, color 0.2s ease;
}

.style-nav.style2 li:not(.empty):hover {
  transform: translateY(5px);
}

.style-nav.style2 li.active {
  border-bottom: 2px solid #44a2d2 !important;
  color: #44a2d2;
}

.style-nav.style1 li:not(.empty):hover {
  background: #44a2d2;
  color: white;
}

.style-nav.style1 li.active {
  border-bottom: 2px solid #44a2d2 !important;
  background: #44a2d2;
  color: white;
}
.styleCardContent {
  background: white;
  min-height: 12rem;
  height: 100%;
}
.padding {
  padding: 1rem;
}
.form-body {
  padding: 20px;
  background-color: white;
}
.form-body form {
  margin-bottom: 20px;
}
.bttn {
  font-family: Montserrat;
  width: max-content;
  margin-top: 0.5rem;
  color: white;
  border: 0;
  border-radius: inherit;
  padding: 5px;
  font-size: 12px;
  cursor: pointer;
  margin-left: 0.5rem;
}
.bttn-blue {
  background-color: #44a2d2;
}
.bttn-red {
  background-color: #dc3545;
}
.bttn-green {
  background-color: #28a745;
}
</style>
